import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 24px;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.primary};

  .tablePedidos:not(td) {
    background-color: #e6f7ff !important;
  }

  .disabled-row {
    background-color: #ffdada;
  }
`;
export const StepsStyle = styled.div`
  .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot,
  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon .ant-steps-icon-dot {
    background: #389e0d;
  }
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: #f0f0f0;
  }
`;
export const TitleLabel = styled.div`
  padding-bottom: 10px;
`;
